module.exports = __webpack_public_path__ + "b27682b23ec4a8a58806a96249aab228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/assets/leo.jpg
// module id = 1044
// module chunks = 0